import {
  SET_PERSONAL_INFO,
  SET_NOK_INFO,
  SET_GUARANTOR_INFO,
  //   SET_DOCUMENTS,
  CLEAR_AGENT_DETAILS,
  SET_UPLOADED_DOCS,
  INVALIDATE_UPLOADED_DOC,
} from "../types/onBoarding";
import store from "../store";
import { removeObjEmptyValues } from "utils/helper";

const dispatch = store.dispatch;

export const setPersonalDetails = (payload) => {
  dispatch({
    type: SET_PERSONAL_INFO,
    payload,
  });
};

export const setNOKDetails = (payload) => {
  dispatch({
    type: SET_NOK_INFO,
    payload,
  });
};

export const setGuarantorsDetail = (payload) => {
  dispatch({
    type: SET_GUARANTOR_INFO,
    payload,
  });
};

export const clearAgentDetails = () => {
  dispatch({
    type: CLEAR_AGENT_DETAILS,
  });
};

export const setUploadedDocs = (payload) => {
  let newPayload = removeObjEmptyValues(payload);

  for (var key in newPayload) {
    if (key !== "id") newPayload[key] = true;
  }

  dispatch({
    type: SET_UPLOADED_DOCS,
    payload: newPayload,
  });
};

export const inValidateUploadedDoc = (name, value) =>
  dispatch({
    type: INVALIDATE_UPLOADED_DOC,
    payload: { name, value },
  });
